import { useQuery } from "@tanstack/react-query";
import { QuestionnaireApi } from "../questionnaire.api";
import { questionnaireKeys } from "./questionnaire.keys";

export const useQuestionnaireDefinitionsQuery = () => {
  return useQuery({
    queryKey: questionnaireKeys.definitions(),
    queryFn: () => QuestionnaireApi.getDefinitions(),
    staleTime: Infinity,
  });
};
